const initialState = {
  addOns: [],
  allAddOns: [],
  addOnsRest: null,
};

const addOnsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_ADDONS_SUCCESS":
      return {
        ...state,
        addOns: action.payload,
      };
    case "GET_ADDONS_SUCCESS":
      return {
        ...state,
        allAddOns: action.payload?.hits,
        addOnsRest: action.payload?.rest,
      };
    default:
      return state;
  }
};

export default addOnsReducer;
